import { render } from "./ProductsComponent.vue?vue&type=template&id=5deffcf6"
import script from "./ProductsComponent.vue?vue&type=script&lang=js"
export * from "./ProductsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__